var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.eject}},[_vm._v("\n  "+_vm._s(_vm.msg)),(this.text.length > 20)?_c('span',{staticClass:"lan"},[_vm._v("全部")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }